  function suscrpoppuCerrar() {
    localStorage.setItem("popup_cerrado", Date.now().toString());
    document.getElementById("suscrpoppu-wrapper").style.display = "none";
  }

  document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.getElementById("suscrpoppu-wrapper");
    const yaSuscrito = localStorage.getItem("ya_suscrito");
    const popupCerrado = localStorage.getItem("popup_cerrado");
    const unDiaEnMs = 24 * 60 * 60 * 1000;

    const mostrarPopup = () => {
      wrapper.style.display = "flex";
    };

    const urlParams = new URLSearchParams(window.location.search);
    const formFueEnviado = urlParams.get("customer_posted") === "true";

    if (formFueEnviado) {
      localStorage.setItem("ya_suscrito", "true");

      // Mostrar mensaje de gracias
      document.getElementById("suscrpoppu-contenido").style.display = "none";
      const originalImg = document.getElementById("suscrpoppu-img-original");
      const graciasImg = document.getElementById("suscrpoppu-img-gracias");
      if (originalImg) originalImg.style.display = "none";
      if (graciasImg) graciasImg.style.display = "block";

      document.getElementById("suscrpoppu-gracias").style.display = "block";
      wrapper.style.display = "flex";

      // Cierre automático
      setTimeout(() => {
        wrapper.style.display = "none";
      }, 5000);
    } else if (!yaSuscrito) {
      const diferencia = Date.now() - parseInt(popupCerrado || "0");
      if (!popupCerrado || diferencia > unDiaEnMs) {
        setTimeout(mostrarPopup, 1000);
      }
    }
  });